<template>
  <div class=kiosks-page>
    <div class="row">
      <div class="col-md-12">
        <div class="row titleDiv">
          <div class="col-md-12">
            <!-- <div class="row">
              <div class="col-md-12">
                <h2 style="font-size: 1.5rem; margin-bottom: 1rem;">{{$t('menu.kiosks')}}</h2>
              </div>
            </div> -->
            <form v-if="kiosks.length > 0">
              <div class="row kioskFilters">
                <div class="col-md-8 multi kioskFilters">
                  <label>
                    {{ $t('menu.kiosks') }}:
                  </label>
                  <multiselect
                    v-model="selectedKiosks"
                    track-by="id"
                    label="name"
                    :placeholder="'kiosks.select_kiosks' | translate"
                    :options="kiosks"
                    :searchable="true"
                    :allow-empty="true"
                    :multiple="true"
                    :disabled="kiosks.length<2">
                    <span slot="noResult">{{'patients.noResults'| translate}}</span>
                  </multiselect>
                </div>
                <div class="col-md-4 kioskFilters">
                  <label style="margin-top: -3px;">
                    {{ $t('leads.table.date_range') }}:
                  </label>
                  <div class="form-group" style="margin-bottom: 2rem;">
                    <div class="input-group datesFilterKiosk">
                      <va-date-picker v-if="currentLanguage() === 'pt'"
                        id="date-picker-range"
                        :config=datePickerConfigPT
                        v-model="datesFilterKiosk"
                        placeholder="  ---"
                      />
                      <va-date-picker v-if="currentLanguage() === 'es'"
                        id="date-picker-range"
                        :config=datePickerConfigES
                        v-model="datesFilterKiosk"
                        placeholder="  ---"
                      />
                      <va-date-picker v-if="currentLanguage() !== 'pt' && currentLanguage() !== 'es'"
                        id="date-picker-range"
                        :config=datePickerConfigEN
                        v-model="datesFilterKiosk"
                        placeholder="  ---"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div v-else-if="!isloading && kiosks.length < 1" class="row">
              <div class="col-md-12">
                <p>{{'kiosks.no_kiosks'| translate}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-for="kiosk in kiosksData"  :key="kiosk.serial">
      <div div class="col-md-12">
        <va-card>
          <div>
            <p><b>{{kiosk.name}} ({{kiosk.serial}})</b></p>
          </div>
          <activity-graph :kiosk="kiosk"></activity-graph>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import ActivityGraph from './ActivityGraph'
import { Portuguese as PTLocale } from 'flatpickr/dist/l10n/pt'
import { Spanish as ESLocale } from 'flatpickr/dist/l10n/es'
import * as LocalStorageKeys from '@/local-storage/LocalStorageKeys'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'

PTLocale.firstDayOfWeek = 1
PTLocale.rangeSeparator = ' a '

export default {
  name: 'kiosks',
  components: {
    Multiselect,
    ActivityGraph
  },
  props: {
    component: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      baseStats: [],
      currentBaseStatsIndex: -1,
      periodStats: [],
      currentPeriodStatsIndex: -1,
      isloading: false,
      baseCounterValues: [0, 0],
      baseKiosksValues: [0, 0, 0, 0],
      kiosks: [],
      selectedKiosks: [],
      kiosksData: [],
      fromDate: this.moment().subtract(30, 'days').format('YYYY-MM-DD'),
      untilDate: this.moment().format('YYYY-MM-DD'),
      datesFilterKiosk: '',
      datePickerConfigPT: {
        mode: 'range',
        locale: PTLocale
      },
      datePickerConfigEN: {
        mode: 'range',
        locale: {
          firstDayOfWeek: 1
        }
      },
      datePickerConfigES: {
        mode: 'range',
        locale: ESLocale
      }
    }
  },
  methods: {
    currentLanguage () {
      return Vue.i18n.locale()
    },
    limitText (count) {
      let text = this.$t('tables.multiselect_limitText_and') + count + this.$t('tables.multiselect_limitText_others')
      return text
    },
    loadKiosksInfo: function () {
      this.isloading = true
      this.$http({
        url: this.component.service.url + '/activities'
      }).then((response) => {
        this.kiosks = response.data
        if (this.kiosks.length) {
          let selectedKiosks = LocalStorageHelper.get(LocalStorageKeys.FILTERS_KIOSKS)
          if (selectedKiosks && selectedKiosks.length > 0) {
            this.selectedKiosks = selectedKiosks
          } else if (this.kiosks.length <= 3) {
            this.selectedKiosks = this.kiosks.slice(0, 3)
          }
          this.currentBaseStatsIndex = 0
        }
        // this.updateBaseData()
        this.isloading = false
      }).catch((error) => {
        console.log(error)
      })
    },
    loadKioskData: function (selectedIndex) {
      this.isloading = true
      this.$http({
        url: this.component.service.url + '/activities/' + this.selectedKiosks[selectedIndex].id + '?from=' + this.fromDate + '&until=' + this.untilDate
      }).then((response) => {
        this.kiosksData.splice(selectedIndex, 1, response.data)
        this.isloading = false
      }).catch((error) => {
        console.log(error)
        this.selectedKiosks.splice(selectedIndex, 1)
      })
    },
    syncKioskData: function () {
      // removed kiosk
      for (let dataIndex = this.kiosksData.length - 1; dataIndex >= 0; dataIndex--) {
        let kioskFound = false
        for (let selectedIndex = this.selectedKiosks.length - 1; selectedIndex >= 0; selectedIndex--) {
          if (this.kiosksData[dataIndex].serial === this.selectedKiosks[selectedIndex].serial) {
            kioskFound = true
            break
          }
        }
        if (!kioskFound) {
          this.kiosksData.splice(dataIndex, 1)
        }
      }
      // add selected kiosks
      for (let selectedIndex = 0; selectedIndex < this.selectedKiosks.length; selectedIndex++) {
        let kioskFound = false
        for (let dataIndex = 0; dataIndex < this.kiosksData.length; dataIndex++) {
          if (this.kiosksData[dataIndex].serial === this.selectedKiosks[selectedIndex].serial) {
            kioskFound = true
            break
          }
        }
        if (!kioskFound) {
          this.kiosksData.splice(selectedIndex, 0, {})
          this.loadKioskData(selectedIndex)
        }
      }
    },
    loadDateFilter (start, end) {
      switch (this.currentLanguage()) {
        case 'pt':
          this.datesFilterKiosk = start + ' a ' + end
          break
        case 'es':
          this.datesFilterKiosk = start + ' a ' + end
          break
        default:
          this.datesFilterKiosk = start + ' to ' + end
      }
    }
  },
  computed: {
    daysDifference: function () {
      let from = this.moment(this.fromDate)
      let until = this.moment(this.untilDate)
      return until.diff(from, 'days')
    }
  },
  watch: {
    datesFilterKiosk: function () {
      if (this.datesFilterKiosk.match(/[0-9]{4}-[0-9]{2}-[0-9]{2} to [0-9]{4}-[0-9]{2}-[0-9]{2}/)) {
        this.fromDate = this.datesFilterKiosk.slice(0, 10)
        this.untilDate = this.datesFilterKiosk.slice(14, 24)
        this.kiosksData.splice(0)
        this.syncKioskData()
      } else if (this.datesFilterKiosk.match(/[0-9]{4}-[0-9]{2}-[0-9]{2} a [0-9]{4}-[0-9]{2}-[0-9]{2}/)) {
        this.fromDate = this.datesFilterKiosk.slice(0, 10)
        this.untilDate = this.datesFilterKiosk.slice(13, 23)
        this.kiosksData.splice(0)
        this.syncKioskData()
      } else if (this.datesFilterKiosk === '') {
        this.kiosksData.splice(0)
        this.syncKioskData()
      }
    },
    selectedKiosks: function () {
      this.syncKioskData()
      LocalStorageHelper.set(LocalStorageKeys.FILTERS_KIOSKS, this.selectedKiosks)
    }
  },
  mounted () {
    this.loadDateFilter(this.moment().subtract(30, 'days').format('YYYY-MM-DD'), this.moment().format('YYYY-MM-DD'))
    this.loadKiosksInfo()
  }
}

</script>

<style lang="scss">
.kiosks-page {
  .date-picker-wrapper{
    z-index: 0 !important;
  }

  .multi .multiselect {
    margin-bottom: 48px;
    &.multiselect--active {
      margin-bottom: 0;
    }
  }

  .multi .multiselect__tag {
    background-color: #29c4a9;
  }

  .multi .multiselect__option--highlight {
    background-color: #29c4a9;
  }

  .multi .multiselect__option--highlight::after {
    background-color: #29c4a9;
  }

  .multi .multiselect__option--selected {
    background-color: #d9d9d9;
  }

  .multi .multiselect__option--selected.multiselect__option--highlight {
    background-color: #e34a4a;
  }

  .multi .multiselect__option--selected.multiselect__option--highlight::after {
    background-color: #e34a4a;
  }

  .multi .multiselect--disabled .multiselect__select {
    background: none;
  }

  .titleCard .widget .widget-body {
    padding-bottom: 1rem !important;
  }

  .kioskFilters .va-date-picker {
    min-width: -webkit-fill-available;
    min-width: -moz-available;
    .va-input__container {
      border: none;
      &__content-wrapper {
        padding-right: 5px;
        padding-left: 2px;
      }
      &__input {
        padding-bottom: 5px !important;
        margin-top: 0.125rem;
        font-size: 90%;
      }
    }
  }

  .kioskFilters input {
    min-height: 40px;
    // border: 1px solid #00000020;
    height: auto;
    background-color: #ffffff !important;
    border-radius: .4rem;
  }

  .kioskFilters>label {
    justify-content: normal;
    font-size: 0.6rem;
    color: #29c4a9;
    font-weight: 600;
    text-transform: uppercase;
    top: -0.6rem;
    left: 0;
    margin-bottom: 0;
  }

  .titleDiv {
    background-color: #e9e9e9;
    border-radius: .5rem;
    min-width: -webkit-fill-available;
    min-width: -moz-available;
    margin-bottom: 2rem;
    padding-top: 1.25rem;
  }

  // .datesFilterKiosk a {
  //   font-size: 0.9rem;
  //   text-transform: uppercase;
  // }

  // .datesFilterKiosk input {
  //   margin-top: -3px;
  //   min-height: 40px;
  //   padding-left: 0.5rem;
  //   // background-color: #ffffff !important;
  //   border-radius: .4rem;
  //   border: 1px solid #e8e8e8;
  // }
}
</style>
